export const color = {
  blue: "#007bff",
  green: "#28a745",
  gray: "#6c757d",
  red: "#ff073a",
  shine: "#65C5FD",
  lightBlue: "#151D33",
  lightRed: "#331427",
  lightGreen: "#182829",
  lightGray: "#1C1C2B",
  orange: "#FD7E14",
  darkOrange: "#332B21",
  lightOrange: "#5E4B1C",
  black: "#161625",
  lightBlack: "#1E1E30",
};

export const COLORSCHEME = {
  BLACK_0: "#312E2B",
  BLACK_1: "#272522",
  BLACK_2: "#22201E",
  BLACK_3: "#1F1E1B",
  GRAY_0: "#c2c9cf",
  GRAY_1: "#7b8085",
  GRAY_2: "#53585C",
  GRAY_3: "#313538",
  WHITE_0: "#8f8f88",
  WHITE_1: "#B3B3B2",
  WHITE_2: "#FFF",
};
